const updates = [
  { date: '2026.07.30', tag: '片库更新', text: '本周新增高分电影32部、热播剧集18部，含《庆余年第二季》最新集和《周处除三害》高清版' },
  { date: '2026.07.28', tag: '功能优化', text: '播放器全面升级，新增4K画质选项和智能缓存功能，观影流畅度提升40%' },
  { date: '2026.07.25', tag: '专题上新', text: '「豆瓣9分以上动画电影」和「深夜美食纪录片合集」两大专题正式上线' },
  { date: '2026.07.22', tag: '片库更新', text: '韩剧专区大幅扩充，《眼泪女王》全集上线，同步更新多部高分韩剧资源' },
  { date: '2026.07.18', tag: '站点公告', text: '移动端适配全面优化，手机和平板观影体验大幅提升，加载速度提高50%' },
  { date: '2026.07.15', tag: '片库更新', text: '悬疑剧场新增8部高分作品，含《漫长的季节》《隐秘的角落》同款口碑好剧' },
  { date: '2026.07.12', tag: '合作进展', text: '与多个影视资源平台达成内容对接，西瓜视频免费和91在线视频资源覆盖更全面' },
  { date: '2026.07.08', tag: '功能优化', text: '搜索功能智能化升级，支持按类型、评分、年份等多维度精准查找影视内容' },
  { date: '2026.07.05', tag: '专题上新', text: '「2025年度高分电影TOP50」和「好莱坞科幻大片全收录」专题同步上线' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-4">
            实时动态
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            糖心视频的每一次更新，都是为了让追剧体验更好
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-background-300 hidden sm:block"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pb-7 last:pb-0">
                <div className="relative z-10 w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 border-2 border-primary-200 shrink-0 hidden sm:flex">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 font-mono whitespace-nowrap">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '片库更新' ? 'bg-primary-100/70 text-primary-700' :
                      item.tag === '专题上新' ? 'bg-accent-100/70 text-accent-700' :
                      'bg-secondary-100/70 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}